/**
 * Options Wrapper Classes
 */

const optionsWrapperGeneralClasses = 'w-full py-3 box-content border-2 max-h-40 overflow-auto scrollbar';
const optionsWrapperPositionClasses = 'absolute left-0 translate-y-0.5 -translate-x-0.5 top-full z-50';
const optionsWrapperColorClasses = 'bg-white border-neutrals-300 shadow-lv4';

/**
 * Option Classes
 */

const optionClasses =
  'flex flex-wrap items-center gap-3 px-4 py-2 cursor-pointer text-neutrals-700 paragraph-s font-medium';

const optionActiveClasses = 'bg-neutrals-200';
const optionSelectedClasses = 'bg-secondaryPurple-50 text-secondaryPurple-600';

const optionIconClasses = 'transition-colors duration-300 fill-neutrals-800';

const optionHighlightedTextClasses = 'font-bold';

/**
 * Blog Theme
 */

const inputOptionsBlogTheme = {
  optionsWrapperThemeClasses: `${optionsWrapperGeneralClasses} ${optionsWrapperPositionClasses} ${optionsWrapperColorClasses}`,
  optionThemeClasses: optionClasses,
  optionActiveThemeClasses: optionActiveClasses,
  optionSelectedThemeClasses: optionSelectedClasses,
  optionIconThemeClasses: optionIconClasses,
  optionHighlightedTextThemeClasses: optionHighlightedTextClasses,
};

export default inputOptionsBlogTheme;
